import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './Customers.css';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import CustomersItem from './CustomersItem/CustomersItem';
import imageCust1 from '../../images/customers/customers-1.jpg';
import imageCust2 from '../../images/customers/customers-2.jpg';
import imageCust3 from '../../images/customers/customers-3.jpg';
import imageCust4 from '../../images/customers/customers-4.jpg';
import imageCust5 from '../../images/customers/customers-5.jpg';
import imageCust7 from '../../images/customers/customers-7.jpg';
import { Carousel } from 'react-bootstrap';


const Customers = () => {
    const { t, i18n } = useTranslation();
    return (
        <section id="customers" className="customers">
            <div className="container" data-aos="zoom-in"
                data-aos-duration="700" >

                <div className="section-title">
                    <h2>{t('customers')}</h2>
                    <p>{t('An_introductory_glimpse')}</p>

                    <div className="customers-item">
                        <Carousel>
                            <Carousel.Item interval={5000}>
                                <img src={imageCust1} className="customers-img" />
                                <CustomersItem name={t('Holiday_Beach')} charac={t('Hotel&resort')} describe={t('One_of_the_largest')} />
                            </Carousel.Item>
         
                            <Carousel.Item interval={5000}>
                                <img src={imageCust2} className="customers-img" />
                                <CustomersItem name={t('Mountain_breeze_resort')} charac={t('Hotel&resort')} describe={t('One_of_the_huge')} />
                            </Carousel.Item>
                            
                            <Carousel.Item interval={5000}>
                                <img src={imageCust3} className="customers-img" />
                                <CustomersItem name={t('Kaisar_Palace')}charac={t('Hotel&Restaurant')} describe={t('A_very_modern')} />
                            </Carousel.Item>

                            <Carousel.Item interval={5000}>
                                <img src={imageCust4} className="customers-img" />
                                <CustomersItem name={t('ROYAL_INN')} charac={t('Hotel&Restaurant')} describe={t('A_very_large_hotel')}/>
                            </Carousel.Item>



                            <Carousel.Item interval={5000}>
                                <img src={imageCust5} className="customers-img" />
                                <CustomersItem name={t('Shamcafe')} charac={t('Cafe&Restaurant')} describe={t('Very_large_restaurant')} />
                            </Carousel.Item>
                            


                            <Carousel.Item interval={5000}>
                                <img src={imageCust7} className="customers-img" />
                                <CustomersItem name={t('Turquoise')} charac={t('Cafe&Restaurant')} describe={t('A_very_famous_restaurant')} />
                            </Carousel.Item>


                        </Carousel>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Customers
